
import { useState } from "react";
import { Card } from '@mui/material';
import { Avatar, Box, Typography } from "@mui/material";
import MessageSuccess from "../../../../messages/messageSuccess";
import MessageError from "../../../../messages/messageError";
import api from "../../../../services/api";
import ShortNome from "../../../../utils/ShortNome";
import DateHora from "../../../../utils/dateHora";
import Editor from "../../../../ckeditor/editor";
import TextFormatado from "../../../../utils/TextFormatado";
import ButtonLeft from "../../../../utils/buttonLeft";
import InputDocUpload from "../../../../utils/inputFileUpload/inputDocUpload";
import HeaderGestorConfigs from "../../../../utils/headerGestorConfigs";


export default function ResponseExpediente({ expediente, userId, setUpdate }) {
    const [messageSuccess, setMessageSuccess] = useState('')
    const [messageError, setMessageError] = useState('')
    const [respostaExpediente, setRespostaExpediente] = useState('')
    const [open, setOpen] = useState(false)

    async function HandleChangeFile(file, name) {
        setRespostaExpediente((prevCadastro) => ({ ...prevCadastro, [name]: file }))
    }

    const sendResposta = async () => {
        setUpdate(false)
        setOpen(true)
        setMessageSuccess('')
        setMessageError('')

        const formData = new FormData();
        formData.append('resposta', respostaExpediente?.conteudo);
        formData.append('anexoDespacho', respostaExpediente?.anexo);
        formData.append('expedienteId', expediente?._id);
        formData.append('userId', userId);

        await api.patch('/expediente/finalize', formData)
            .then(response => {
                setOpen(false)
                setMessageSuccess('Resposta enviada com sucesso e o expediente foi concluído')

                // api.patch('/expediente/change-status', { id, userId, 'status': 'Concluído' })
                setUpdate(true)

                // window.setTimeout(() => {
                //     navigate(-1)
                // }, 5000);

            }).catch(error => {
                // console.log(error)
                setOpen(false)
                setMessageError(error.response.data.message)
            })
    }

    return (
        expediente?.resposta ?
            <Card style={{ padding: 20, position: 'relative', marginTop: 10 }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Avatar src={expediente.despachoPor?.dadosPessoais.fotoURL} style={{ marginRight: 5 }} />
                    <Typography lineHeight={1} noWrap variant="body1">
                        <ShortNome nome={expediente.despachoPor?.dadosPessoais?.nome} />
                        <br />
                        <small><DateHora date={expediente?.updatedAt} /></small>
                    </Typography>
                </div>

                <Box sx={{ backgroundColor: 'rgba(0, 0, 0, 0.03)', padding: '2rem', borderRadius: '4px', mb: 4 }}>
                    <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Resposta ao expediente:</strong>  <TextFormatado texto={expediente?.resposta ?? ''} /> </Typography>
                </Box>

                <embed
                    id="pdfIframeExpedienteEsposta"
                    title={`PDF Viewer`}
                    src={[expediente?.anexoDespacho]}
                    width="100%"
                    height="800px"
                    style={{ border: 'none' }}
                />
            </Card>
            :
            <Card style={{ padding: 20, position: 'relative', marginTop: 10 }}>
                {messageSuccess && <MessageSuccess message={messageSuccess} />}
                {messageError && <MessageError message={messageError} />}

                <HeaderGestorConfigs title={'Responder expediente'} />
                <Editor
                    setEditorData={setRespostaExpediente}
                    editorData={respostaExpediente?.resposta}
                />

                {/* ANEXAR DOCUMENTOS COMPLEMENTARES */}
                <InputDocUpload
                    imputLigth={true}
                    fullWidth={true}
                    onFileSelect={HandleChangeFile}
                    inputName={'anexo'}
                    inputDescription={'Anexo do Despacho'}
                    inputTitle={'Adicionar anexo'}
                />

                <ButtonLeft
                    title={'Enviar Resposta'}
                    disabled={!respostaExpediente?.conteudo || open}
                    funcao={sendResposta}
                    load={open}
                />
            </Card>
    )
}